import { useRouter } from 'next/router';
import React, { useEffect, useRef } from 'react';
import { ROUTES, ROUTES_DESCRIPTION, ROUTES_REGEX } from '~/constants/ROUTES';
import { isRegexPathEquivalent } from '~/helpers/path';
import { StyledContainer } from './styles';
const RouteAnnouncer: React.FC = () => {
  const router = useRouter();
  const announcerRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const routeKey = Object.keys(ROUTES_REGEX).find(key => isRegexPathEquivalent(ROUTES_REGEX[key as keyof typeof ROUTES], router.asPath));
    const routeDescription = ROUTES_DESCRIPTION[routeKey as keyof typeof ROUTES_DESCRIPTION];
    document.title = routeDescription;
    if (announcerRef?.current && routeDescription) {
      // Small delay to ensure announcement happens after route change
      setTimeout(() => {
        if (announcerRef?.current) {
          announcerRef.current.innerText = routeDescription;
          announcerRef.current?.focus?.();
        }
      }, 500);
    }
  }, [router]);
  return <StyledContainer ref={announcerRef} tabIndex={-1} data-sentry-element="StyledContainer" data-sentry-component="RouteAnnouncer" data-sentry-source-file="index.tsx" />;
};
export default RouteAnnouncer;